export const useCountdown = () => {
  const countDownInterval = ref<ReturnType<typeof setInterval> | null>(null);
  const countDown = ref(60);

  const getCountDownTime = (date: string | number) => {
    const date1: any = new Date(date);
    const date2: any = new Date();
    return Math.ceil(Math.abs(date1 - date2) / 1000);
  };

  const runCountDown = () => {
    if (countDown.value === 0) {
      clearInterval(countDownInterval.value as ReturnType<typeof setInterval>);
    } else {
      countDown.value--;
    }
  };

  const startResendCountdown = (value: number | string) => {
    countDown.value = getCountDownTime(value);
    clearInterval(countDownInterval.value as ReturnType<typeof setInterval>);
    runCountDown();
    countDownInterval.value = setInterval(() => {
      runCountDown();
    }, 1000);
  };

  return {
    startResendCountdown,
    countDown,
  };
};
